<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('footerLocation') }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.hotelName }}</span>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('contact') }}</h4>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('quickLinks') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
			</div>
			<div class="row">
				<div class="columns column12 footer-logo-row">
					<h4>MEMBER OF:</h4>
					<!--<div class="footer-logo-member member2" />-->
					<div class="footer-logo-member member3" />
					<a
						class="footer-logo-member member4"
						:href="qualityLodgingsUrl"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Quality Lodgings"
					/>
					<div class="footer-logo-member member5" />
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<div class="bottomfooter-row">
						<p class="align-left">
							<a
								href="https://www.porterforhotels.com/hotel-websites"
								target="_blank"
								rel="noopener noreferrer"
								title="Hotel website design by Porter"
							>
								Hotel Website Design
							</a>
							by:
							<a href="https://porterforhotels.com" target="_blank">
								<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="" />
								Porter</a
							>
						</p>
						<div class="menu align-right">
							<span v-for="(item, idx) in bottomfooter[locale]" :key="item.filename">
								<nuxt-link :to="item.filename">
									{{ item.header }}
								</nuxt-link>
								<span v-if="idx < bottomfooter[locale].length - 1" class="divider">|</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();
const qualityLodgingsUrls = {
	nl: 'https://qualitylodgings.com/nl/herangtunet-boutique-hotel',
	en: 'https://qualitylodgings.com/en/herangtunet-boutique-hotel',
	de: 'https://qualitylodgings.com/de/herangtunet-boutique-hotel',
};
const qualityLodgingsUrl = computed(() => qualityLodgingsUrls[locale.value] || qualityLodgingsUrls.en);

if (!defaults.value) {
	await fetchDefaults();
}
</script>

<style lang="scss" scoped>
.footers {
	color: var(--footer-color);
	background: var(--footer-background-color);
	font-size: calc(var(--body-font-size) - 1px);

	a,
	span {
		color: var(--footer-color);
		text-decoration: none;
	}

	h3,
	h4 {
		color: var(--footer-color);
		letter-spacing: 1px;
	}

	h4 {
		font-size: 1.5em;
	}
}

.main-footer {
	padding: 75px 0 50px;

	p {
		font-size: 0.9em;
	}

	a,
	span {
		display: block;
	}

	a:hover {
		text-decoration: underline;
	}

	.columns {
		padding-top: 25px;

		&:first-child {
			padding-top: 0;
		}
	}

	.footer-logo {
		background: url('~/assets/images/logo-herangtuner-lodge-footer-white.png') no-repeat center center;
		background-size: 268px;
		width: 268px;
		height: 244px;
	}
}

.bottomfooter-row {
	display: flex;
	align-items: center;

	.menu {
		margin-left: auto;

		.divider {
			padding: 0 5px;
		}
	}
}

.footer-logo-row {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	gap: 10%;
	align-items: center;
	margin: 25px auto 0;

	h4 {
		margin: 0;
	}

	.footer-logo-member {
		background: url('~/assets/images/footerlogos/01_member.png') no-repeat center center;
		background-size: 100%;
		height: 108px;
		width: 291px;

		/*
		&.member2 {
			background: url('~/assets/images/footerlogos/02_member.png') no-repeat center center;
			background-size: 100%;
			width: 78px;
		}
*/

		&.member3 {
			background: url('~/assets/images/footerlogos/06_member.png') no-repeat center center;
			background-size: 100%;
			width: 93px;
		}

		&.member4 {
			background: url('~/assets/images/footerlogos/ql-member-white.png') no-repeat center center;
			background-size: 100%;
			width: 100px;
		}

		&.member5 {
			background: url('~/assets/images/footerlogos/05_member.png') no-repeat center center;
			background-size: 100%;
			width: 84px;
		}
	}
}

.author-footer {
	font-size: 0.9em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	.border {
		background: #fff;
		width: 100%;
		height: 1px;
	}

	img {
		max-width: 20px;
		margin: 0 1px 0 2px;
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 0 auto 20px;
	}

	.footer-logo-row {
		display: none;
	}
}

@media (max-width: 880px) {
	.bottomfooter-row {
		flex-flow: column-reverse wrap;
		align-items: center;
		width: 100%;

		.menu {
			margin: 10px auto;
		}

		p {
			margin: 5px auto;
		}
	}
}

@media (max-width: 580px) {
	footer {
		text-align: center;
	}

	.main-footer {
		padding: 20px 0;

		.footer-logo {
			display: none;
		}
	}
}
</style>
